module.exports = __webpack_public_path__ + "img/keycap-digit-seven.ed4966de.png";